<div class="span-12-9-9 col">
  <p-panel [header]="'Representatives_Title' | translateWF: 'Representatives'">
    @if (!viewOnly) {
      <ng-template pTemplate="icons">
        <p-button [label]="'Add' | translateWF: 'Add'" variant="outlined" icon="pi pi-plus" (click)="openRepresentativeDetailsModal()" />
      </ng-template>
    }
    <p-card data-variant="compact">
      <p-table [value]="representatives" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]" [rowHover]="true" dataKey="__rowKey" selectionMode="single">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Representatives_FirstName' | translateWF: 'First Name' }}</th>
            <th>{{ 'Representatives_LastName' | translateWF: 'Last Name' }}</th>
            <th>
              {{ 'Representatives_PhoneNumber' | translateWF: 'Phone Number' }}
            </th>
            @if (!viewOnly) {
              <th>{{ 'Actions' | translateWF: 'Actions' }}</th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-representative let-i="rowIndex">
          <tr [attr.data-key]="representative.id || 'temp-' + i">
            <td>{{ representative.firstName }}</td>
            <td>{{ representative.lastName }}</td>
            <td>{{ representative.phoneNumber }}</td>
            @if (!viewOnly) {
              <td>
                <p-button type="button" icon="pi pi-pencil" (click)="openRepresentativeDetailsModal(representative)"></p-button>
              </td>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="viewOnly ? 3 : 4" class="text-center">
              {{ 'General_NoRecords' | translateWF: 'No records found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </p-panel>
</div>
